<template>
    <div>
        <div v-if="this.$route.query.password === 'superhipersecretisimo'">
            <div>
                <SvgComponent 
                    :zonas="zonas" 
                    :place="place"
                />
            </div>

            <div style="max-width: 80em; margin: auto;">
                <b-table hover :items="zonas" :fields="fields" id="zonas-table">
                    <template #cell(svg_code)="data">
                        <input v-model="data.item.svg_code"/>
                    </template>
                    <template #cell(actions)="data">
                        <button @click="saveRow(data.item)">Guardar</button>
                    </template>
                </b-table>
            </div>
        </div>
        <div v-else>
            No tienes permiso para estar aqui
        </div>
    </div>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        data() {
            return {
                zonas: [],
                fields: [
                    'id',
                    'place_id',
                    'name',
                    'svg_code',
                    'actions'
                ],
            }
        },
        created() {
            this.getZonas();
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            getZonas(place_id) {
                const params = {
                    filters: {
                        place_id: this.place.id
                    },
                    place_id: this.place.id
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                });
            },
            saveRow(item) {
                let params = {
                    zona_id: item.id,
                    svg_code: item.svg_code
                };
                this.$store.dispatch(this.config.getVuexAlias('superadmin.svg.edit'), params);
            }
        },
        components: {
            SvgComponent
        },
    }
</script>
